//动态api

import request from '@/utils/request'

export function getDynamic(data) {
  return request.post('http://i-wq.net/wqproject_company/index.php/66?app=api&mod=User&act=companyFeed', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

//动态api

// import request from '@/utils/request'

// export function getDynamic(data) {
//   return request.post('http://www.00800.com.cn/wqproject_company/index.php/66?app=api&mod=User&act=companyFeed', data, {
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
// }